import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container, Form,  Divider, Button } from 'semantic-ui-react';
import { DateInput } from 'semantic-ui-calendar-react';
import useReadUser from '../../Hooks/Users/useReadUser';
import useListBadgeOfMerits from '../../Hooks/Settings/useListBadgeOfMerits';
import useReadBadgeOfMerit from '../../Hooks/Users/BadgeOfMerit/useReadBadgeOfMerit';
import useUpdateBadgeOfMerit from '../../Hooks/Users/BadgeOfMerit/useUpdateBadgeOfMerit';
import { MessageContext } from '../../Context/MessageContext';

const EditBadgeOfMerit= (props) => {

    const { t } = useTranslation();
    const { addMessage, removeMessage, messages } = useContext(MessageContext);
    const { userId, badgeOfMeritId } = useParams();
    const { user, readUser } = useReadUser();
    const { badgeOfMerits, listBadgeOfMerits } = useListBadgeOfMerits();
    const { badgeOfMerit, readBadgeOfMerit } = useReadBadgeOfMerit();
    const { updateBadgeOfMerit } = useUpdateBadgeOfMerit();

    const [ date, setDate ] = useState(null);
    const [ selectedBadgeOfMerit, setSelectedBadgeOfMerit ] = useState(null);
    const [ description, setDescription ] = useState('');

    useEffect(() => {
        (async() => {
            await listBadgeOfMerits();
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let badgeOfMeritOptions = []
    if (badgeOfMerits) {
        badgeOfMerits.map(badge => {
            const tmp = {
                key: badge.Id,
                text: badge.Name,
                value: badge.Id
            }
            badgeOfMeritOptions.push(tmp)
            return badge;
        })
    }

    useEffect(() => {
        (async() => {
            await readBadgeOfMerit(userId,badgeOfMeritId);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        (async() => {
            await readUser(userId);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Set user data
    useEffect(() => {
        (async () => {
            if (badgeOfMerit.data && badgeOfMerit.data.Id) {
                setDate(badgeOfMerit.data.Date ? new Date(badgeOfMerit.data.Date).toLocaleDateString() : '');
                setDescription(badgeOfMerit.data.Description || '');
                setSelectedBadgeOfMerit(badgeOfMerit.data.BadgeOfMerit || null);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [badgeOfMerit]);

    const handleSave = async () => {
        messages.map(msg => removeMessage(msg.id));

        //validate
        if(!date || !selectedBadgeOfMerit) {
            addMessage({type: "error", header: t('message.fillInRequiredInformation'), body: t('message.requiredMarkedWithAsterisk')})
            window.scrollTo(0, 0)
        } else {
            // Format date
            let dateParts = []
            let dateISO = null;
            if(date) {
                dateParts=date.split('.');
                dateISO=new Date(dateParts[2] + "-" + dateParts[1].padStart(2,"0") + "-" + dateParts[0].padStart(2,"0")).toISOString();
            }

            //create data
            let data = {
                "date": dateISO,
                "badgeOfMerit": selectedBadgeOfMerit,
                "description": description
            }

            //save
            let result = null;
            result = await updateBadgeOfMerit(userId,badgeOfMeritId,data);

            if(result.status === 200) {
                props.history.goBack();
            }
        }
    }

    return (
        <div className='userform'>
            <Form>
                <Container className="userlist">
                    <h1>{t('heading.user')}</h1>
                    
                    <h2>{t('heading.user')}</h2>
                    <div>{user.data && user.data.FirstName} {user.data && user.data.LastName}</div>
                
                    <h2>{t('badgeOfMerit.date')}<sup><i className='icon asterisk'></i></sup></h2>
                    <DateInput
                        localization='fi'
                        dateFormat={'DD.MM.YYYY'}
                        value={date || ""}
                        iconPosition="right"
                        onChange={(ev, {value}) => setDate(value) }
                        closable={true}
                        popupPosition='bottom left'
                    />

                    <h2>{t('heading.badgeOfMerit')}<sup><i className='icon asterisk'></i></sup></h2>
                    <Form.Select
                        value={selectedBadgeOfMerit}
                        options={badgeOfMeritOptions}
                        onChange={(e, {value}) => setSelectedBadgeOfMerit(value)}
                    />
                
                    <h2>{t('badgeOfMerit.description')}</h2>
                    <Form.TextArea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </Container>
            </Form>
            <Divider/>
            <Button onClick={() => handleSave()}>{t('general.save')}</Button>
            <Button onClick={() => props.history.goBack()}>{t('general.cancel')}</Button>
        </div>
    )

}

export default EditBadgeOfMerit;